import { useQuery } from '@tanstack/react-query';
import { getOwnerList } from '@/lib/coloc-api/admin';

export const useGetOwners = () => {
  return useQuery({
    queryKey: ['getOwnerList'],
    queryFn: async () => {
      const response = await getOwnerList();
      return response.data;
    },
  });
}; 